import Vue from 'vue';
import {handleErrors} from '@/services/ErrorHandling';

const self = Vue.prototype;

export default {
  getSettingsGeneral() {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminSettings)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  updateSettingsGeneral(body) {
    return new Promise((resolve, reject) => {
      self.axios.put(self.$apiRouter.adminSettings, body)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  getDepartments() {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminSettings + '/department')
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  }
}
